<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/order-online.jpg');">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>About Us</h1>
                        <p>"Craving wings or sandwiches? Order online and we'll have it hot and ready!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="aboutSection mt-4 mb-3">
    <div class="container-fluid px-4">
        <div class="row">
            <div class="col-md-6">
                <h2 class="currentRoute">Our Story</h2>
                <p class="paragraph">{{aboutContent}}</p>
            </div>
            <div class="col-md-6 mt-5 items text-end">
                <img [src]="aboutImage" class="itemImage" alt="About">
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>